import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { User } from '../../../models/user.model';
import { GlobalSwal } from '../../../styles/swal.style';
import { AppService } from '../../../models/app.service.model';
import { Company } from '../../../models/company.model';
import { Settings } from '../../../models/settings.model';
import { Contact } from '../../../models/contact.model';
import { TreasuryAccount } from '../../../models/treasury.account.model';
import { Service } from '../../../models/service.model';
import { Product } from '../../../models/product.model';
import { AccountingAccount } from '../../../models/accounting.account.model';
import { AccountingEntry } from '../../../models/accounting.entry.model';
import { Error } from '../../../models/error.model';
import { CompanyAccountingAccounts } from '../../../models/company.accounting.accounts.model';
import { AccountingAccountDA } from '../../../services/admin/accounting.account.service';
import { StateLanguage } from '../../../languages/config/StateLanguage';
import { getError } from '../../../languages/translations/response';
import { errorWebHandler } from '../../../scripts/error.web.handler.script';

export interface SalePageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  userLoggedIn: User | null,
  appServiceForUser: AppService | null,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  accountingAccountsForCompany: AccountingAccount[] | null,
  accountingCreditEntriesForCompany: AccountingEntry[] | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null,
  contactsForCompany: Contact[] | null,
  servicesForCompany: Service[] | null,
  productsForCompany: Product[] | null,
  accountingIncomeAccountsForCompany: AccountingAccount[] | null,
  setAccountingIncomeAccountsForCompany: Dispatch<SetStateAction<AccountingAccount[] | null>>,
  loadSettingsForCompany: Function,
  loadAccountingCreditEntriesForCompany: Function,
  loadContactsForCompany: Function,
  loadServicesForCompany: Function,
  loadProductsForCompany: Function,
  loadAccountingIncomeAccountsForCompany: Function
};

let errorResponse: Error, accountingIncomeAccountsResponse: CompanyAccountingAccounts;

const SalePage: React.FunctionComponent<SalePageProps> = props => {
  const {setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, accountingCreditEntriesForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, loadSettingsForCompany, loadAccountingCreditEntriesForCompany, loadContactsForCompany, loadServicesForCompany, loadProductsForCompany} = UseOutletContext()
  const {lang} = StateLanguage()

  const [accountingIncomeAccountsForCompany, setAccountingIncomeAccountsForCompany] = useState<AccountingAccount[] | null>(null)

  const loadAccountingIncomeAccountsForCompany = async (id_company: string) => {
    await AccountingAccountDA.getAccountingAccounts(id_company, [], ['3'], []).then( (response) => {
      if (response.status === 200) {
        accountingIncomeAccountsResponse = response.data
        setAccountingIncomeAccountsForCompany(accountingIncomeAccountsResponse.accounting_accounts)
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    })
  }

  useEffect( () => {
    if (companyForUser) {
      loadAccountingIncomeAccountsForCompany(companyForUser.id)
      loadContactsForCompany(companyForUser.id)
      loadProductsForCompany(companyForUser.id)
      loadServicesForCompany(companyForUser.id)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser])

  return (
    <Outlet context={{setRoute, userLoggedIn, appServiceForUser, companyForUser, settingsForCompany, accountingAccountsForCompany, accountingCreditEntriesForCompany, treasuryAccountsForCompany, contactsForCompany, servicesForCompany, productsForCompany, accountingIncomeAccountsForCompany, setAccountingIncomeAccountsForCompany, loadSettingsForCompany, loadAccountingCreditEntriesForCompany, loadContactsForCompany}}></Outlet>
  );
}

export function UseOutletContextSale() {
  return useOutletContext<ContexType>()
};

export default SalePage;
